import { Box, styled } from '@mui/material';

/** Vertical stack wrapping actions + tabs rows. No horizontal padding — DrawerHeaderSlot already applies paddingInline: 16. */
export const HeaderComposition = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	gap: 8,
});

/** Row that spreads left and right action groups to opposite ends */
export const ActionsRow = styled(Box)({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	gap: 8,
	paddingBlock: 4,
});
